import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'backoffice-create-excel-button',
  templateUrl: './create-excel-button.component.html',
  styleUrls: ['./create-excel-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateExcelButtonComponent {
  @Input() isLoadingExcel!: boolean;
  @HostBinding('class.disabled')
  @Input()
  disabled!: boolean;
}
